// extracted by mini-css-extract-plugin
module.exports = {"link":"HeaderNavItem_link__goiNQ","linkDesk":"HeaderNavItem_linkDesk__I9KG0","linkMobile":"HeaderNavItem_linkMobile__B5FPV"};